import { createAction, props } from '@ngrx/store';
import { MessageConversation } from '../models/message-conversation.model';
import { withGenesysCloudStoreNameSpace } from 'common/store/genesys-cloud/common/action-namespace';
import { ConversationActionCreator, ConversationsActionCreator } from 'common/store/genesys-cloud/conversations/common/models/conversation-action.model';
import { WrapUpCode } from 'common/store/genesys-cloud/conversations/common/models/wrap-up-code.model';

export const withNameSpace = withGenesysCloudStoreNameSpace('Message Conversations');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const loadMessageConversations = createAction(
  withNameSpace('Load message conversations')
);

export const messageConversationsLoaded: ConversationsActionCreator<MessageConversation> = createAction(
  withNameSpace('Message conversations loaded'),
  props<{ conversations: MessageConversation[] }>()
);

export const messageConversationChanged: ConversationActionCreator<MessageConversation> = createAction(
  withNameSpace('Message conversation changed'),
  props<{ conversation: MessageConversation }>()
);

export const acceptMessageConversation = createAction(
  withNameSpace('Accept message conversation'),
  props<{ conversationId: string, focus: boolean }>()
);

export const closeMessageConversation = createAction(
  withNameSpace('Close message conversation'),
  props<{ conversationId: string }>()
);

export const skipWrapUpForMessageConversation = createAction(
  withNameSpace('Skip wrap-up for message conversation'),
  props<{ conversationId: string }>()
);

export const loadWrapUpsForMessageConversation = createAction(
  withNameSpace('Load wrap-ups for message conversation'),
  props<{ conversationId: string }>()
);

export const wrapUpsLoadedForMessageConversation = createAction(
  withNameSpace('Wrap-ups loaded for message conversation'),
  props<{ conversationId: string, wrapUpCodes: WrapUpCode[] }>()
);

export const saveWrapUpForMessageConversation = createAction(
  withNameSpace('Save wrap up for message conversation'),
  props<{ conversationId: string, wrapUpCode: string }>()
);

export const evictMessageConversation = createAction(
  withNameSpace('Evict message conversation'),
  props<{ conversationId: string }>()
);

export const transferMessageConversationToUser = createAction(
  withNameSpace('Transfer Message Conversation to User'),
  props<{ conversationId: string, participantId: string, userId: string }>()
);

export const transferMessageConversationToQueue = createAction(
  withNameSpace('Transfer Message Conversation to Queue'),
  props<{ conversationId: string, participantId: string, queueId: string }>()
);

export const transferMessageConversationSuccess = createAction(
  withNameSpace('Transfer Message Conversation Success'),
  props<{ conversationId: string }>()
);

export const transferMessageConversationFailure = createAction(
  withNameSpace('Transfer Message Conversation Failure'),
  props<{ conversationId: string }>()
);
